/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Summary_Overdue_SinceInputs */



/**
* | output |
* | --- |
* | "billing month ended {date}" |
*
* @param {Partner_Summary_Overdue_SinceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_overdue_since = /** @type {((inputs: Partner_Summary_Overdue_SinceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_Overdue_SinceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abrechnungsmonat endete am ${i?.date}`)
	return /** @type {LocalizedString} */ (`billing month ended ${i?.date}`)
});